export enum ShopifyMediaType {
  Image = "IMAGE",
  Video = "VIDEO",
  ExternalVideo = "EXTERNAL_VIDEO",
  Model3d = "MODEL_3D",
}
